import { useMemo, useState } from "react";

import "./PreviewCard.css";
import LogoEmail from "../../../assets/LOGO - FOOTER.png";

const LOGO_CANDIDATES = [
  LogoEmail,
];

export default function PreviewCard({ campaign }) {
  const [logoIndex, setLogoIndex] = useState(0);
  const [logoUnavailable, setLogoUnavailable] = useState(false);

  const bodyLines = useMemo(() => {
    const body = String(campaign?.body || "");

    return body.trim()
      ? body.split("\n")
      : [];
  }, [campaign?.body]);

  function handleLogoError() {
    const nextIndex = logoIndex + 1;

    if (nextIndex < LOGO_CANDIDATES.length) {
      setLogoIndex(nextIndex);
      return;
    }

    setLogoUnavailable(true);
  }

  return (
    <section className="campaign-card preview-card">
      <div className="campaign-card-header">
        <div className="campaign-card-title">
          <span className="campaign-card-icon">
            <i className="fa-solid fa-eye" aria-hidden="true" />
          </span>

          <div>
            <h2>Vista previa</h2>
            <p>Así verán el correo los destinatarios.</p>
          </div>
        </div>
      </div>

      <div className="email-preview-shell">
        <div className="email-preview">
          <header className="preview-top">
            {!logoUnavailable ? (
              <img
                src={LOGO_CANDIDATES[logoIndex]}
                alt="TE AYUDO"
                onError={handleLogoError}
              />
            ) : (
              <div className="preview-logo-fallback">
                <strong>TE AYUDO</strong>
                <span>Centro multidisciplinar infantojuvenil</span>
              </div>
            )}
          </header>

          <main className="preview-content">
            <h3>{campaign?.subject?.trim() || "Sin asunto"}</h3>

            {bodyLines.length > 0 ? (
              <div className="preview-message">
                {bodyLines.map((line, index) =>
                  line.trim() ? (
                    <p key={`${line}-${index}`}>{line}</p>
                  ) : (
                    <div
                      key={`empty-${index}`}
                      className="preview-line-break"
                      aria-hidden="true"
                    />
                  ),
                )}
              </div>
            ) : (
              <div className="preview-empty">
                Empieza a escribir el mensaje para ver la vista previa.
              </div>
            )}
          </main>

          <footer className="preview-footer">
            <strong>TE AYUDO</strong>
            <span>Psicología · Logopedia · Atención multidisciplinar</span>

            <div className="preview-socials" aria-label="Redes y contacto">
              <a
                href="https://te-ayudo.es/reservar"
                target="_blank"
                rel="noreferrer"
                title="Página web"
              >
                <i className="fa-regular fa-calendar-check" aria-hidden="true" />
              </a>

              <a
                href="https://www.instagram.com/centroteayudo.es/"
                target="_blank"
                rel="noreferrer"
                title="Instagram"
              >
                <i className="fa-brands fa-instagram" aria-hidden="true" />
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61577033498767"
                target="_blank"
                rel="noreferrer"
                title="Facebook"
              >
                <i className="fa-brands fa-facebook-f" aria-hidden="true" />
              </a>

              <a
                href="https://wa.me/601866199"
                target="_blank"
                rel="noreferrer"
                title="WhatsApp"
              >
                <i className="fa-brands fa-whatsapp" aria-hidden="true" />
              </a>
            </div>

            <a
              className="preview-website"
              href="https://centroteayudo.es"
              target="_blank"
              rel="noreferrer"
            >
              centroteayudo.es
            </a>
          </footer>
        </div>
      </div>
    </section>
  );
}